import type { IconSvgObject } from './types';

const SignatureIcon: IconSvgObject = [
  ["path", { d: "M22 12.5001C18 16.0122 17.4279 10.621 15.3496 11.0165C13 11.4637 11.5 16.5001 13 16.5001C14.5 16.5001 12.5 10.5 10.5 12.5556C8.5 14.6111 7.85936 17.2946 6.23526 15.3025C-1.5 5.81446 4.99998 -1.14994 8.16322 3.45685C10.1653 6.37256 6.5 16.9769 2 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SignatureIcon;
